import Vue from "vue";
import Vuex from "vuex";
import VueRouter from 'vue-router'
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import store from "./store";
import router from "./router";
import Helpers from "./helpers";
import server from "./server";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Unicon from 'vue-unicons';
import Toasted from 'vue-toasted';
import {
  uniMessage, uniEditAlt, uniGooglePlay, uniShareAlt, uniCog , uniCopyAlt, uniWifiSlash, uniRobot, uniTimes, uniSync, uniHeart, uniQuestionCircle, uniVolume, uniVolumeMute
} from 'vue-unicons/src/icons'
Unicon.add([uniEditAlt,uniMessage,uniGooglePlay,uniShareAlt,uniCog,uniCopyAlt,uniWifiSlash,uniRobot,uniTimes,uniSync,uniHeart,uniQuestionCircle,uniVolume,uniVolumeMute]);

// make store available in browser console for development purpose
if (process.env.NODE_ENV=='development') {
  window.store = store;
  window.helpers = Helpers;
  window.server = server;
  window.router = router;
}
// in production show some funny message ഹീ ഹീ ഹീ!!! and nicely handle the errors
else {
  Helpers.browser.hackWarn();
  Vue.config.errorHandler = (error) => {
    console.error(error);
  }
}

// Mobile app needed functions
if(window.cordova){
  window.Server = server;
  window.Router = router;
  window.Store = store;
}

// To remove adwares remove window.open functionility
window.openNewWindow = window.open;
window.open = function(){};

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Unicon);
Vue.use(Toasted);

Vue.config.productionTip = false;

window.addEventListener("resize", Helpers.browser.calculateSize);
server.initMainRoom();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
